__turbopack_context__.v({
  "align-center": "x9KajG_align-center",
  "align-justify": "x9KajG_align-justify",
  "align-left": "x9KajG_align-left",
  "align-right": "x9KajG_align-right",
  "bold": "x9KajG_bold",
  "italic": "x9KajG_italic",
  "size-l": "x9KajG_size-l",
  "size-m": "x9KajG_size-m",
  "size-s": "x9KajG_size-s",
  "size-xs": "x9KajG_size-xs",
  "spacing": "x9KajG_spacing",
  "text": "x9KajG_text",
});
